// extracted by mini-css-extract-plugin
export default {"message-open":"message_message-open__bmizw","message-close":"message_message-close__sUTPu","success-text":"message_success-text__NtfBt","error-text":"message_error-text__3IW4B"};